module.exports = __webpack_public_path__ + "img/queue_card_small.8596ffea.svg";